import * as React from 'react';
import { Search } from 'lucide-react';
import { Input } from './input';

/**
 * Search field with the leading icon — the icon+input combo extracted from
 * its hand-written copies. A thin wrapper over `Input`, so all input props
 * pass through; width via className (e.g. `className="w-64"`).
 */
export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Applied to the wrapper div (widths, margins). */
  containerClassName?: string;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ containerClassName, className, type, 'aria-label': ariaLabel, ...props }, ref) => {
    return (
      <div className={['relative', containerClassName].filter(Boolean).join(' ')}>
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          ref={ref}
          aria-label={ariaLabel ?? 'Search'}
          type={type ?? 'search'}
          className={['pl-9', className].filter(Boolean).join(' ')}
          {...props}
        />
      </div>
    );
  }
);
SearchInput.displayName = 'SearchInput';

export default SearchInput;
